<template lang="pug">
    settings-bookings
</template>

<script>
export default {
    name: 'settings-bookings-page',
}
</script>
